import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=30e50836&scoped=true&v-if=product&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductCard.vue?vue&type=style&index=1&id=30e50836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e50836",
  null
  
)

/* custom blocks */
import block0 from "./ProductCard.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)
import block1 from "./ProductCard.vue?vue&type=custom&index=1&blockType=docs"
if (typeof block1 === 'function') block1(component)

component.options.__file = "ProductCard.vue"
export default component.exports